import { atom } from 'recoil'
import { ITeamDefence } from 'screens/Protection/protection.types'

interface IMyTeamTableAtomState {
  items: ITeamDefence[]
  filters: {
    search?: string
    roomId?: string
    date?: Date | null
  }
}

const myTeamTableAtom = atom<IMyTeamTableAtomState>({
  key: 'myTeamExpert',
  default: { items: [], filters: { search: '', roomId: '', date: null } },
})
export default myTeamTableAtom
